import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { ExploreContentApi_ContentType } from '~src/spacesPlatform/models/IContent';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { selectFlowsOnSiteEnabled } from '../../../flow/selectors/FlowSelectors';
import { contentCountsRequest } from '../../actions/ContentCountsActions';
import { selectContentCounts } from '../../selectors/ContentCountsSelector';
import { selectCurrentlyApplicableContentTypes, selectHiddenContentTypeForCurrentSpace } from '../../selectors/ContentFilterSelectors';
import { SpaceInfoTypeContentCount } from '../../state/ContentCountsState';
import {
  isFavoritesSpace,
  isPersonalSpace,
  isProjectSpace,
  isRecycleBinSpace,
  isSharedWithMeSpace,
  isSingleCollectionSpace,
  isSiteUserContentSubspace
} from '../../state/SpaceInfo';
import { FilterByTypePanel, FilterByTypePanelDispatchProps, FilterByTypePanelOwnProps, FilterByTypePanelStateProps } from './FilterByTypePanel';

const getCounts = (state: AppState): SpaceInfoTypeContentCount<ExploreContentApi_ContentType> => {
  if(isFavoritesSpace(state.spaceInfo)){
    return selectContentCounts<'favorites'>(state, 'favorites');
  } else if(isRecycleBinSpace(state.spaceInfo)){
    return selectContentCounts<'recyclebin'>(state, 'recyclebin');
  } else if(isProjectSpace(state.spaceInfo)){
    return selectContentCounts<'project'>(state, 'project');
  } else if(isSiteUserContentSubspace(state.spaceInfo)){
    return selectContentCounts<'siteuser'>(state, 'siteuser');
  } else if(isSharedWithMeSpace(state.spaceInfo)) {
    return selectContentCounts<'sharedWithMe'>(state, 'sharedWithMe');
  } else if(isPersonalSpace(state.spaceInfo)) {
    return selectContentCounts<'personal'>(state, 'personal');
  } else if (isSingleCollectionSpace(state.spaceInfo)) {
    return selectContentCounts<'collection'>(state, 'collection');
  }
};

export const mapStateToSpaceProps: MapStateToProps<FilterByTypePanelStateProps> =
  (state: AppState) => ({
    contentCounts: getCounts(state),
    contentFilter: selectCurrentlyApplicableContentTypes(state),
    showWorkbooksAsViews: state.contentExplorer.showWorkbooksAsViews,
    flowsEnabled: selectFlowsOnSiteEnabled(state),
    hiddenContentTypes: selectHiddenContentTypeForCurrentSpace(state),
    spaceInfo: state.spaceInfo
  });

export const mapDispatchToProps: MapDispatchToProps<FilterByTypePanelDispatchProps> =
  (dispatch) => bindActionCreators({
    onComponentDidUpdate: contentCountsRequest
  },
  dispatch);

export const ConnectedFilterByTypePanel: React.ComponentClass<FilterByTypePanelOwnProps> =
  connect(mapStateToSpaceProps, mapDispatchToProps)(FilterByTypePanel);
